var header = $('.js-darken-on-scroll'); // Select the header with the class .js-darken-on-scroll

$(window).scroll(function() {
    var scrollTop = $(window).scrollTop(); // Get the current vertical position of the scroll bar

    var opacity = 0; // Default opacity is 0
    if (scrollTop > 1000) {
        opacity = 0.6; // Set opacity to 0.6 after the first 1000px
    }

    header.css('background', 'rgba(0, 0, 0, ' + opacity + ')'); // Apply the calculated opacity to the background
});
